@if (!isDuration15Minutes()) {
  <header 
    class="card__header" 
    [attr.data-header-point-scroll-index]="indexCard()"
  >
    <div class="header__overlay"></div>
    
    <div 
      class="header__saturated-duration"
      [style.justifyContent]="
        checkIsnotSturedPoint() ? 'flex-end' : 'space-between'
      "
    >
      @if(isVerySaturatedPoint()) {
        <app-very-satured-chip />
      } @else if (isSaturatedPoint()) {
        <app-satured-chip />
      }
      
      <span class="header__duration">
        {{ point().duration | duration }}
      </span>
    </div>
    
    <img 
      [style.view-transition-name]="'timeline-img-' + point().id"
      [src]="point().img" 
      [attr.alt]="('Imagen' | translate) + ' ' + point().title"
    >
  </header>
}